import { IPermissionsContext } from "../../ipermissions-context/ipermissions-context.interface";
import { IPermissions } from "../../ipermissions/ipermissions.interface";
import {
  isPageTypeWorkOrder,
  isUserAlsoCreator,
} from "../../ipermissions-context/ipermissions-context.functions";
import { enablePermissions } from "../../ipermissions/ipermissions.functions";
import { IPermissionPolicyEvaluator } from "../../ipermissions/ipermission-policy.type";

export const contentCreatorPolicy = (next?: IPermissionPolicyEvaluator) => (
  context: IPermissionsContext,
  permissions: IPermissions
) => {
  // AKA - Assignee
  // console.log("checkContentCreatorPolicy -->");
  if (isPageTypeWorkOrder(context) && isUserAlsoCreator(context)) {
    // console.log("checkContentCreatorPolicy --> TRUE");

    enablePermissions(
      permissions,
      "canEdit",
      "manageExecBriefs",
      "manageProducts",
      "manageReviewers",
      "manageStatus",
      "manageWorkOrders",
      "updateReviewStatus"
    );
  }

  if (next) {
    return next(context, permissions);
  }
};
